import React from 'react';
import UserProfileWidget from './community/UserProfileWidget';
import ProfileEfficacyWidget from './community/ProfileEfficacyWidget';
import AIProfileSuggestionsWidget from './community/AIProfileSuggestionsWidget';
import GroupFeedWidget from './community/GroupFeedWidget';
const CommunityDashboard = () => {
  return <div className="space-y-4" data-id="element-785">
      {/* First row - Profile widgets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-786">
        <div className="col-span-1" data-id="element-787">
          <UserProfileWidget data-id="element-788" />
        </div>
        <div className="col-span-1" data-id="element-789">
          <ProfileEfficacyWidget data-id="element-790" />
        </div>
        <div className="col-span-1" data-id="element-791">
          <AIProfileSuggestionsWidget data-id="element-792" />
        </div>
      </div>

      {/* Second row - Feed widget (full width now since match widget is gone) */}
      <div className="grid grid-cols-1 gap-4" data-id="element-793">
        <div className="col-span-1" data-id="element-794">
          <GroupFeedWidget data-id="element-795" />
        </div>
      </div>
    </div>;
};
export default CommunityDashboard;